import { FC } from 'react';
import SelectStores from './SelectStores/SelectStores';

const PublishMenus: FC = () => {
  return <SelectStores />;
};

export default PublishMenus;
